import { OrderActions, TeamActions } from '../models/actions';
import { OrderList, OrdersByHash, OrdersListReducer } from '../models/Order';
import {
  CHANGE_ORDER_STATUS_ERROR,
  CHANGE_ORDER_STATUS_SUCCESS,
  DELETE_ORDERS_ERROR,
  DELETE_ORDERS_REQUEST,
  DELETE_ORDERS_SUCCESS,
  FETCH_TEAM_ORDERS_ERROR,
  FETCH_TEAM_ORDERS_REQUEST,
  FETCH_TEAM_ORDERS_SUCCESS,
  SET_STATUS,
} from '../constants/actionTypes';

export const initialState: OrdersListReducer = {
  byHash: {},
  byId: [],
  count: 0,
  loading: false,
  error: false,
  ordersDeleted: false,
};

export default (state = initialState, action: TeamActions | OrderActions) => {
  switch (action.type) {
    case FETCH_TEAM_ORDERS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case FETCH_TEAM_ORDERS_SUCCESS: {
      const { orders, count } = action.payload;

      return {
        ...state,
        byHash: orders
          .reduce((byHash: OrdersByHash, order: OrderList) => ({
            ...byHash,
            [order.id]: order,
          }), state.byHash),
        byId: orders.map(({ id }: OrderList) => id),
        loading: false,
        count,
      };
    }
    case DELETE_ORDERS_REQUEST:
      return {
        ...state,
        loading: true,
        ordersDeleted: false,
      };
    case DELETE_ORDERS_SUCCESS: {
      const updatedById = state.byId.filter(
        (id: number) => !action.payload.orderIds.includes(id),
      );
      const updatedByHash = updatedById.reduce((byHash: OrdersByHash, itemId: number) => ({
        ...byHash,
        [itemId]: state.byHash[itemId],
      }), {});

      return ({
        ...state,
        loading: false,
        byId: updatedById,
        byHash: updatedByHash,
        ordersDeleted: true,
      });
    }
    case DELETE_ORDERS_ERROR:
    case CHANGE_ORDER_STATUS_ERROR:
    case FETCH_TEAM_ORDERS_ERROR:
      return {
        ...state,
        error: true,
        loading: false,
      };
    case SET_STATUS:
      return {
        ...state,
        loading: true,
      };
    case CHANGE_ORDER_STATUS_SUCCESS: {
      const { orderId, status } = action.payload;

      return {
        ...state,
        loading: false,
        error: false,
        byHash: {
          ...state.byHash,
          [orderId]: {
            ...state.byHash[orderId],
            status,
          },
        },
      };
    }
    default:
      return state;
  }
};
